import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatDialogActions, MatDialogClose, MatDialogContent } from '@angular/material/dialog'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'app-add-speaker-dialog',
  standalone: true,
  imports: [MatButton, MatDialogActions, MatDialogContent, TranslateModule, MatDialogClose, FormsModule, MatFormField, MatLabel, MatInput],
  templateUrl: './add-speaker-dialog.component.html',
  styleUrl: './add-speaker-dialog.component.scss',
})
export class AddSpeakerDialogComponent {
  speakerName = ''
}
